import { Callout, Intent } from '@blueprintjs/core';
import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';

import {
  hasAnyPermission,
  hasSignedRequiredDocuments,
  isAuthenticated,
} from '@f/services/authentication/authentication.selectors';

import LoadingScreen from '../loading-screen/LoadingScreen';

function ProtectedRoute({
  component: RouteComponent,
  isAuthenticated,
  isProcessing,
  hasSignedRequiredDocuments,
  hasAccess,
  ...rest
}) {
  if (!isAuthenticated) {
    setTimeout(() => {
      window.location.assign(`/internal/auth/sign-in?from=${window.location.href}`);
    }, 300);
    return <LoadingScreen caption="Redirecting to sign in..." />;
  }
  if (isAuthenticated && !hasSignedRequiredDocuments) {
    return <Redirect to="/sign-documents" />;
  }
  if (isAuthenticated && !hasAccess) {
    return (
      <Callout intent={Intent.DANGER} title="Not authorized">
        You don't have sufficient permissions to view the page
      </Callout>
    );
  }

  return <Route {...rest} render={props => <RouteComponent {...props} />} />;
}

export default connect((state, { allowedPermissions }) => ({
  isAuthenticated: isAuthenticated(state),
  isProcessing: state.authentication.processing > 0,
  hasSignedRequiredDocuments: hasSignedRequiredDocuments(state),
  hasAccess: hasAnyPermission(state, allowedPermissions),
}))(ProtectedRoute);
